import { render } from "./Error500.vue?vue&type=template&id=3f1f43bd"
import script from "./Error500.vue?vue&type=script&lang=ts"
export * from "./Error500.vue?vue&type=script&lang=ts"
script.render = render

export default script